import React from 'react'
import ZonalCoordinatorAddPTM from '../../features/zonalcoordinator/ZonalCoordinatorAddPTM'

const ZonalCoordinatorAddPTMPage = () => {
  return (
   <ZonalCoordinatorAddPTM/>
  )
}

export default ZonalCoordinatorAddPTMPage